import { FC } from 'react'
import SettingsMenu from 'components/SettingsMenu'
import withAside from './withAside'

const withAsideMenu = (Component: FC) => withAside(Component, SettingsMenu)

export default withAsideMenu
